/**
 * Safely access localStorage with error handling
 * @param {string} key - The localStorage key
 * @returns {string|null} - The stored value or null if not available/accessible
 */
export const getSafeLocalStorageItem = (key) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem(key);
    }
  } catch (error) {
    console.warn(`Failed to access localStorage for key "${key}":`, error);
  }
  return null;
};

/**
 * Safely set localStorage with error handling
 * @param {string} key - The localStorage key
 * @param {string} value - The value to store
 * @returns {boolean} - Success status
 */
export const setSafeLocalStorageItem = (key, value) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(key, value);
      return true;
    }
  } catch (error) {
    console.warn(`Failed to set localStorage for key "${key}":`, error);
  }
  return false;
};

/**
 * Safely remove localStorage item with error handling
 * @param {string} key - The localStorage key
 * @returns {boolean} - Success status
 */
export const removeSafeLocalStorageItem = (key) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem(key);
      return true;
    }
  } catch (error) {
    console.warn(`Failed to remove localStorage for key "${key}":`, error);
  }
  return false;
};
